import { ScrollView, StyleSheet, Text, View } from "react-native";
import React from "react";
import { c } from "../../styles/constants";
import EmptyContent from "../../Components/EmptyContent";

const AdquirePlan = () => {
  return (
    <ScrollView>
      <View style={{ padding: c.spacing.spacing_md }}>
        <EmptyContent/>
      </View>
    </ScrollView>
  );
};

export default AdquirePlan;

const styles = StyleSheet.create({});
